import { preloadApplicationModules } from './bootstrapPreload';

let workspacePreloadCompleted = false;
let workspacePreloadPromise = null;

export function isWorkspacePreloaded() {
  return workspacePreloadCompleted;
}

/**
 * Preload launcher, app layout, and registered modules (authenticated workspace only).
 * Safe to call multiple times; concurrent calls share one in-flight promise.
 *
 * @param {(progress: object) => void} [onProgress]
 */
export async function preloadAuthenticatedWorkspace(onProgress) {
  if (workspacePreloadCompleted) {
    return { total: 0, failed: 0, succeeded: 0 };
  }

  if (workspacePreloadPromise) {
    return workspacePreloadPromise;
  }

  workspacePreloadPromise = preloadApplicationModules(onProgress)
    .then((result) => {
      workspacePreloadCompleted = true;
      workspacePreloadPromise = null;
      return result;
    })
    .catch((error) => {
      workspacePreloadPromise = null;
      // Fail open — lazy routes still load via Suspense.
      workspacePreloadCompleted = true;
      console.warn('[workspace-preload] Preload failed; continuing with lazy loading.', error);
      return { total: 0, failed: 1, succeeded: 0 };
    });

  return workspacePreloadPromise;
}
